import { useFormik } from "formik";
import PropTypes from "prop-types";
import React from "react";
import { HTTP_CREATED, HTTP_UPDATED } from "../helpers/AxiosHelpers";

/**
 * generates formik form to edit/create feed
 * @returns formik object
 */
const useFeedForm = ({
  // entity,
  authUser,
  dispatch,
  ReviewActions,
  getEntity = () => {},
  edit = false,
  // idField,
  initialData = { message: "", rating: 0 },
  feedId,
  setSelectedFeed,
}) => {
  const { message, rating } = initialData;
  // const editFieldName = edit ? "edit_" : "";
  const reviewFormik = useFormik({
    initialValues: {
      message: message,
      rating: rating,
      id: feedId,
      user_id: authUser.id,
    },
    onSubmit: (values) => {
      if (!edit) {
        return dispatch(ReviewActions.createEntity(values)).then((r) => {
          if (r.status === HTTP_CREATED) {
            getEntity();
          }
        });
      }
      return dispatch(ReviewActions.updateEntity(values)).then((r) => {
        if (r.status === HTTP_UPDATED) {
          getEntity();
          setSelectedFeed(null);
        }
      });
    },
  });
  // const { handleSubmit, getFieldProps } = reviewFormik;
  return reviewFormik;
};

export default useFeedForm;
// useFeedForm.prototypes = {
//   entity: PropTypes.any,
//   edit: PropTypes.bool,
//   dispatch: PropTypes.func.isRequired,
//   ReviewActions: PropTypes.object,
// };
